import { makeStyles, tokens } from '@fluentui/react-components';

import DashboardPeriodicReviewChart from './DashboardPeriodicReviewChart';
import DashboardStatusDistributionChart from './DashboardStatusDistributionChart';
import type { TDashboardStatusChartDatum, TDashboardViewCounters } from '../types/dashboard.types';

const useStyles = makeStyles({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.35fr) minmax(280px, .65fr)',
    gap: tokens.spacingHorizontalL,
    '@media (max-width: 960px)': {
      gridTemplateColumns: '1fr',
    },
  },
});

type TProps = {
  counters: TDashboardViewCounters;
  statusChart: TDashboardStatusChartDatum[];
};

const DashboardStatusAndReviewCharts = ({ counters, statusChart }: TProps) => {
  const classes = useStyles();

  return (
    <div className={classes.grid}>
      <DashboardStatusDistributionChart data={statusChart} />
      <DashboardPeriodicReviewChart counters={counters} />
    </div>
  );
};

export default DashboardStatusAndReviewCharts;
